/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 適用中のプラン
 * @export
 * @interface ApplyingPlan
 */
export interface ApplyingPlan {
    /**
     * プランID
     * @type {string}
     * @memberof ApplyingPlan
     */
    id: string;
    /**
     * 現在利用しているプラン名
     * @type {string}
     * @memberof ApplyingPlan
     */
    name: string;
    /**
     * 料金ラベル
     * @type {string}
     * @memberof ApplyingPlan
     */
    priceLabel: string;
    /**
     * プラン開始日 YYYY/mm/dd形式
     * @type {string}
     * @memberof ApplyingPlan
     */
    planStartDate: string | null;
    /**
     * プラン終了日 YYYY/mm/dd形式
     * @type {string}
     * @memberof ApplyingPlan
     */
    planEndDate: string | null;
    /**
     * 自動更新かどうか
     * @type {boolean}
     * @memberof ApplyingPlan
     */
    isAutoRenewable: boolean | null;
    /**
     * 一括支払いか
     * @type {boolean}
     * @memberof ApplyingPlan
     */
    isLumpSumPayment: boolean;
    /**
     * 適用中のサブプラン
     * @type {string}
     * @memberof ApplyingPlan
     */
    programName: string | null;
    /**
     * 支払い締め日 YYYY/mm/dd
     * @type {string}
     * @memberof ApplyingPlan
     */
    paymentClosingDate: string;
    /**
     * FAX配信が無料か
     * @type {boolean}
     * @memberof ApplyingPlan
     */
    isFaxFree: boolean;
}

export function ApplyingPlanFromJSON(json: any): ApplyingPlan {
    return ApplyingPlanFromJSONTyped(json, false);
}

export function ApplyingPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplyingPlan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'priceLabel': json['price_label'],
        'planStartDate': json['plan_start_date'],
        'planEndDate': json['plan_end_date'],
        'isAutoRenewable': json['is_auto_renewable'],
        'isLumpSumPayment': json['is_lump_sum_payment'],
        'programName': json['program_name'],
        'paymentClosingDate': json['payment_closing_date'],
        'isFaxFree': json['is_fax_free'],
    };
}

export function ApplyingPlanToJSON(value?: ApplyingPlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'price_label': value.priceLabel,
        'plan_start_date': value.planStartDate,
        'plan_end_date': value.planEndDate,
        'is_auto_renewable': value.isAutoRenewable,
        'is_lump_sum_payment': value.isLumpSumPayment,
        'program_name': value.programName,
        'payment_closing_date': value.paymentClosingDate,
        'is_fax_free': value.isFaxFree,
    };
}

